export default __webpack_public_path__ + "static/media/eagle.dfeb6df9.webp";